import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, money, shortDate } from "@/lib/api";
import { Card, StatusBadge } from "@/components/admin/ui";

export default function CustomerDetail() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  useEffect(() => {
    api.get(`/admin/customers/${id}`).then((r) => setC(r.data));
  }, [id]);
  if (!c) return null;
  const a = c.address || {};
  return (
    <div data-testid="admin-customer-detail-page">
      <Link to="/admin/customers" className="inline-flex items-center gap-1.5 text-sm text-zinc-500 hover:text-zinc-950 mb-4"><ArrowLeft size={15} /> Customers</Link>
      <h1 className="text-2xl font-bold mb-1">{c.name}</h1>
      <p className="text-sm text-zinc-500 mb-6">Customer since {shortDate(c.created_at)}</p>
      <div className="grid lg:grid-cols-[1.5fr_1fr] gap-4">
        <Card title={`Orders (${c.orders.length})`}>
          <div className="divide-y divide-zinc-100">
            {c.orders.map((o) => (
              <Link key={o.id} to={`/admin/orders/${o.id}`} className="flex items-center justify-between py-2.5 text-sm hover:bg-zinc-50 -mx-2 px-2 rounded">
                <span className="font-medium">#{o.number}</span>
                <span className="text-zinc-500 flex-1 px-4">{shortDate(o.created_at)}</span>
                <StatusBadge status={o.fulfillment_status} />
                <span className="w-24 text-right">{money(o.total)}</span>
              </Link>
            ))}
          </div>
        </Card>
        <div className="space-y-4">
          <Card title="Contact">
            <a href={`mailto:${c.email}`} className="text-sm text-sky-700 hover:underline break-all">{c.email}</a>
            {c.phone && <p className="text-sm text-zinc-600 mt-1">{c.phone}</p>}
          </Card>
          <Card title="Last shipping address">
            <div className="text-sm text-zinc-700 leading-relaxed">
              <p>{a.line1}</p>{a.line2 && <p>{a.line2}</p>}
              <p>{a.city}{a.state ? `, ${a.state}` : ""} {a.postal_code}</p><p>{a.country}</p>
            </div>
          </Card>
          <Card title="Total spent"><p className="text-2xl font-bold">{money(c.total_spent)}</p></Card>
        </div>
      </div>
    </div>
  );
}
